import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Message } from '@marvelapp/ui';
import { Text } from './Text';
export function InputError(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (_jsx(Message, Object.assign({ kind: "error", mt: "s" }, props, { children: _jsx(Text, { fontSize: "s", children: children }) })));
}
